export const CLOUDCHAT_SUPPORT_SLOT_ATTRIBUTE = 'data-cloudchat-support-slot';

// Assistants only see the conversations assigned to them and manage nothing at
// the account level, so they are not the audience of the Cloud Humans support
// channel — the widget stays hidden for them.
export const SUPPORT_BLOCKED_ROLE = 'assistant';

export const canShowCloudchatSupportWidget = ({ accountId, role } = {}) =>
  Boolean(accountId) && role !== SUPPORT_BLOCKED_ROLE;
